var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.route
    ? _c(
        "router-link",
        {
          staticClass:
            "inline-block text-primary-700 hover:underline hover:text-primary-900",
          attrs: { title: _vm.title, to: _vm.routerTo }
        },
        [_vm._t("default")],
        2
      )
    : _vm.url
    ? _c(
        "a",
        {
          staticClass:
            "inline-block text-primary-700 hover:underline hover:text-primary-900",
          attrs: { target: "_blank", title: _vm.title, href: _vm.url }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "button",
        {
          staticClass:
            "inline-block text-primary-700 hover:underline hover:text-primary-900",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }